"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _minesites = _interopRequireDefault(require("./minesites"));
var _useractivity = _interopRequireDefault(require("./useractivity"));
var _navigation = require("./navigation");
var _oneWeir = require("@weirgroup/one-weir");
var _userdetailsConstants = require("./userdetailsConstants");
var _mainModule = _interopRequireDefault(require("./main.module.css"));
class UserDetails extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedLink: _userdetailsConstants.userDetailsConstants.MINESITES_LINK,
      deleteModal: false,
      deleteUserData: ''
    };
    this.ChangeNavSelected = this.ChangeNavSelected.bind(this);
  }
  ChangeNavSelected(data) {
    this.setState({
      SelectedLink: data.link
    });
  }
  render() {
    const breadcrumbHistoryData = [{
      path: '#',
      title: _userdetailsConstants.userDetailsConstants.MANAGE_YOUR_TEAM,
      callbackHandler: () => this.props.navCallback(0)
    }, {
      path: '#',
      title: _userdetailsConstants.userDetailsConstants.BRCM_MINE_SITE.replace('<MineSiteLabel>', this.props.mineSiteLabel.singular),
      callbackHandler: () => this.props.navCallback(1)
    }, {
      path: '#',
      title: this.props.selectedUser.MineSiteUsers.source
    }];
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-over-ride": "view-user-wrap"
    }, /*#__PURE__*/_react.default.createElement(_oneWeir.Breadcrumb, {
      breadcrumbHistory: breadcrumbHistoryData
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.setName
    }, this.props.selectedUser.MineSiteUsers.source), /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.setNavPosition
    }, /*#__PURE__*/_react.default.createElement(_navigation.UserAccountNavigation, {
      ChangeNavSelected: this.ChangeNavSelected,
      SelectedLink: this.state.SelectedLink
    })), this.state.SelectedLink === _userdetailsConstants.userDetailsConstants.MINESITES_LINK ? /*#__PURE__*/_react.default.createElement(_minesites.default, {
      mines: this.props.mineSites,
      deleteModaltrigger: this.props.deleteModaltrigger,
      deleteUserData: this.props.deleteUserData,
      Modal: this.props.Modal,
      selectedUser: this.props.selectedUser,
      appDetails: this.props.assignedRoles,
      formatDropDownValues: this.formatDropDownValues,
      addTeamMemberCallback: this.props.addTeamMemberCallback,
      deleteMineSite: this.props.deleteMineSite,
      deleteMineData: this.props.deleteMineData,
      deleteMineConf: this.props.deleteMineConf,
      selectedBusinessEntity: this.props.selectedBusinessEntity
    }) : /*#__PURE__*/_react.default.createElement(_useractivity.default, {
      userActivity: this.props.userActivityData,
      selectedUser: this.props.selectedUser,
      addTeamMemberCallback: this.props.addTeamMemberCallback
    }));
  }
}
const mapStateToProps = state => ({
  mineSiteLabel: state.manageYourTeam.mineSiteLabel
});
const mapDispatchToProps = () => ({});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserDetails);